<template>
  <div>
    <navigation></navigation>
    <div class="about text-center mx-auto" style="max-width: 900px">
      <h3>Links & Blogs</h3>

      <div class="card text-left mb-5" style="width: 100%">
        <div class="card-body w-100 mb-2 ">
          <h5 class="card-title">Websites</h5>
          <p class="card-text ">
            <a href="http://bornerbesorgts.org" target="new"
              ><i class="fa fa-external-link"></i> bornerbesorgts.org
              (graphicdesign)<br
            /></a>
            <a href="http://oliverdecrow.com" target="new"
              ><i class="fa fa-external-link"></i> oliverdecrow.com (music
              artistpage)<br
            /></a>
            <a href="http://www.bornutti.com" target="new"
              ><i class="fa fa-external-link"></i> bornutti.com
              (fashiondesign)<br
            /></a>
            <a href="https://hello-trading.de" target="new"
              ><i class="fa fa-external-link"></i> hello-trading.de (forex
              signal service)<br
            /></a>
            <a href="https://oliver-decrow.bandcamp.com/" target="new"
              ><i class="fa fa-bandcamp"></i> Oliver Decrow (bandcamp)<br
            /></a>
            <a href="https://soundcloud.com/oliver-decrow" target="new"
              ><i class="fa fa-soundcloud"></i> Oliver Decrow (soundcloud)<br
            /></a>
            <a href="https://soundcloud.com/g23brecords" target="new"
              ><i class="fa fa-soundcloud"></i> G23b Records (soundcloud)<br
            /></a>
            <a
              href="https://www.youtube.com/channel/UCTfZlzdfiuYX_VDsxHfpVDA"
              target="new"
              ><i class="fa fa-youtube"></i> Cocopalermo86 (youtube-channel)<br
            /></a>
          </p>
        </div>
      </div>

      <div class="card text-left mb-5" style="width: 100%">
        <div class="card-body w-100 mb-2">
          <h5 class="card-title">Social</h5>
          <p class="card-text">
            <a href="https://instagram.com/derborner" target="new"
              ><i class="fa fa-instagram"></i> Borner on Instagram<br
            /></a>
            <a href="https://instagram.com/oliverdecrow" target="new"
              ><i class="fa fa-instagram"></i> Oliver Decrow on Instagram<br
            /></a>
            <a href="https://instagram.com/hello.trading" target="new"
              ><i class="fa fa-instagram"></i> Hello Trading on Instagram<br
            /></a>
            <a href="https://instagram.com/bornutti" target="new"
              ><i class="fa fa-instagram"></i> Bornutti on Instagram<br
            /></a>
            <a href="https://www.facebook.com/oliver.borner/" target="new"
              ><i class="fa fa-facebook"></i> Borner on Facebook<br
            /></a>
            <a
              href="https://www.xing.com/profile/Oliver_Borner3/cv"
              target="new"
              ><i class="fa fa-xing"></i> Borner on Xing<br
            /></a>
            <a href="https://twitter.com/KavalierOliver" target="new"
              ><i class="fa fa-twitter"></i> Borner on Twitter<br
            /></a>
            <a href="https://github.com/oliverborner/" target="new"
              ><i class="fa fa-github"></i> Borner on Github<br
            /></a>
            <a href="https://t.me/OKavalier" target="new"
              ><i class="fa fa-telegram"></i> Borner on Telegram<br
            /></a>
            <a href=" https://www.discogs.com/de/user/Cocopalermo" target="new"
              ><i class="fa fa-music"></i> Discogs Profile<br
            /></a>
          </p>
        </div>
      </div>

      <div class="card text-left mb-5" style="width: 100%">
        <div class="card-body w-100 mb-2">
          <h5 class="card-title">Tumblr & Blogs</h5>
          <p class="card-text">
            <a href="https://oborner.tumblr.com" target="new"
              ><i class="fa fa-tumblr"></i> oborner.tumblr.com (curated
              artblog)<br
            /></a>
            <a href="https://blackleadgrinder.tumblr.com/" target="new"
              ><i class="fa fa-tumblr"></i> blackleadgrinder.tumblr.com <br
            /></a>
            <a href="https://wolfreis.tumblr.com" target="new"
              ><i class="fa fa-tumblr"></i> wolfreis.tumblr.com (writing
              blog)<br
            /></a>

            <a href="https://kessler-schwarz-blog.tumblr.com/" target="new"
              ><i class="fa fa-tumblr"></i> kessler-schwarz-blog.tumblr.com <br
            /></a>

            <a href="http://blog.oliverborner.com/" target="new"
              ><i class="fa fa-external-link"></i> ohmyblog (programming blog)
              <br
            /></a>

            <a
              href="https://holger-john.blogspot.com/search?q=borner"
              target="new"
              ><i class="fa fa-external-link"></i> Borner on Holger John
              Blogspot <br
            /></a>
          </p>
        </div>
      </div>
    </div>
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";
export default {
  components: {
    navigation,
  },
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
